import {
  Box,
  Card,
  CardContent,
  CardActionArea,
  Container,
  Grid,
  Tab,
  Tabs,
} from "@common-ui/ui";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";

//Asset Tabel View
import { AssetTableView } from "../Assets/AssetTableView";

//WorkEvents Tabel View
import { WorkEventsTableView } from "../WorkEvents/WorkEventsTableView";

//Members Tabel View
import UsersTableView from "../org/UsersTableView";

//MyOrg Components
import { MyOrgTree } from "./MyOrgTree";

//Services
import {
  getAssets,
  getOrgWorkEvents,
  getOrgUsers,
  getUserOrgsRelated,
  getOrgPlaces,
} from "../../services";
import {
  ProfileHeader,
  ProfileTitle,
  ProfileSidebar,
  PageLoader,
} from "../../components";

const StyledTab = styled(Tab)({
  fontFamily: "Roboto",
});

const StyledBox = styled(Box)({
  marginBottom: "2rem",
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export const MyOrgProfile = (props) => {
  const orgId = props?.id;
  let router = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [assets, setAssets] = useState([]);
  const [workEvents, setWorkEvents] = useState([]);
  const [members, setMembers] = useState([]);
  const [places, setPlaces] = useState([]);
  const [aggregateCount, setAggregateCount] = useState([]);
  const [orgTreeData, setOrgTreeData] = useState([]);
  const [value, setValue] = useState(0);
  const [placesParent, setPlacesParent] = useState(undefined);
  const [newPlaceParent, setNewPlaceParent] = useState(undefined);
  const [, setCustomer] = useState(null);
  const [, setNewCustomer] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  async function init() {
    try {
      let { assets } = await getAssets(orgId);
      assets && setAssets(assets);

      let workEventsData = await getOrgWorkEvents(orgId);
      workEventsData && setWorkEvents(workEventsData);

      let users = await getOrgUsers(orgId);
      users && setMembers(users);

      let userOrg = await getUserOrgsRelated();
      userOrg && setOrgTreeData(userOrg);

      let placesData = await getOrgPlaces(orgId);
      placesData && setPlaces(placesData);

      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  }

  useEffect(() => {
    let countData = aggregateData(assets, members, workEvents, places);
    setAggregateCount(countData);
  }, [assets, workEvents, members, places]);

  function aggregateData(assetData, membersData, workEventsData, placesData) {
    return [
      { label: "Members", count: membersData?.length },
      { label: "Assets", count: assetData?.length },
      { label: "Works", count: workEventsData?.length },
      { label: "Places", count: placesData?.length },
    ];
  }

  const DISPLAY_TABLE = {
    assets: (
      <StyledBox>
        <AssetTableView
          isLoading={isLoading}
          rows={assets}
          orgId={orgId}
          rowSize={5}
          customer={props.data}
          setCustomer={setCustomer}
          setNewCustomer={setNewCustomer}
          places={places}
          setPlaces={setPlaces}
          placesParent={placesParent}
          setPlacesParent={setPlacesParent}
          newPlaceParent={newPlaceParent}
          setNewPlaceParent={setNewPlaceParent}
          setIsLoading={setIsLoading}
          init={init}
        />
      </StyledBox>
    ),
    workEvents: (
      <StyledBox>
        <WorkEventsTableView
          isLoading={isLoading}
          rowsData={workEvents}
          rowSize={5}
        />
      </StyledBox>
    ),
    members: (
      <StyledBox>
        <UsersTableView users={members} rowSize={5} />
      </StyledBox>
    ),
    moreInfo: <StyledBox>More Info Data Table</StyledBox>,
  };

  return isLoading ? (
    <PageLoader openState={isLoading} />
  ) : (
    <Container disableGutters maxWidth="xl">
      <Grid container>
        <ProfileSidebar>
          <MyOrgTree orgs={orgTreeData} router={router} />
        </ProfileSidebar>
        <Grid item md={10}>
          <Card>
            <CardContent>
              <ProfileTitle
                title={props?.data?.name}
                searchPlaceHolder="Search Organizations, Places, Members & Assets"
              />
            </CardContent>
            <CardActionArea component="span">
              <Tabs value={value} onChange={handleChange}>
                <StyledTab label="Overview" />
                <StyledTab label="Assets" />
                <StyledTab label="Work" />
                <StyledTab label="Members" />
                <StyledTab label="More Info" />
              </Tabs>
            </CardActionArea>
          </Card>
          <Grid item sx={{ padding: "1rem" }}>
            <TabPanel value={value} index={0}>
              <ProfileHeader
                data={props?.data}
                editLink={`/orgs/${props?.data?.id}/edit`}
                profileCount={aggregateCount}
              />
              {DISPLAY_TABLE["assets"]}
              {DISPLAY_TABLE["workEvents"]}
              {DISPLAY_TABLE["members"]}
            </TabPanel>
            <TabPanel value={value} index={1}>
              {DISPLAY_TABLE["assets"]}
            </TabPanel>
            <TabPanel value={value} index={2}>
              {DISPLAY_TABLE["workEvents"]}
            </TabPanel>
            <TabPanel value={value} index={3}>
              {DISPLAY_TABLE["members"]}
            </TabPanel>
            <TabPanel value={value} index={4}>
              {DISPLAY_TABLE["moreInfo"]}
            </TabPanel>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};
